import React, { useEffect } from "react";
import RegisterPermitsCounts from "../components/RegisterPermitsCounts";
import { useGetPermitsCountByStatesMetric, PermitMetricScopeInput } from "../operations/queries/getPermitsCountByStatesMetric";
import { useAppContext } from "../hooks/useAppContext";
import { StateKey } from "../models/globalTypes";

/** Map PascalCase state keys returned by the API to the SCREAMING_SNAKE_CASE StateKey enum. */
const STATE_KEY_MAP: Record<string, StateKey> = {
  Cancelled: StateKey.CANCELLED,
  Completed: StateKey.COMPLETED,
  Expired: StateKey.EXPIRED,
  InProgress: StateKey.IN_PROGRESS,
  Issued: StateKey.ISSUED,
  ReadyToIssue: StateKey.READY_TO_ISSUE,
  Rejected: StateKey.REJECTED,
  Requested: StateKey.REQUESTED,
  RequestInProgress: StateKey.REQUEST_IN_PROGRESS,
};

interface Props {
  scope?: PermitMetricScopeInput;
  /** When provided, the active drill-down state to highlight. */
  selectedState?: StateKey | null;
  /** When provided, the tiles toggle dashboard drill-down state instead of navigating. */
  onSelectState?: (state: StateKey) => void;
}

const RegisterPermitsCountsContainer = (props: Props) => {
  const { currentOrganization, currentPermitRegister } = useAppContext();

  const { getPermitsCountByStatesMetric, data: permitsCountByStates } = useGetPermitsCountByStatesMetric();

  useEffect(() => {
    if (currentOrganization) {
      const activeScope: PermitMetricScopeInput = props.scope || {
        organizationId: currentOrganization.id,
        registerIds: currentPermitRegister?.id ? [currentPermitRegister.id] : null,
      };

      getPermitsCountByStatesMetric({
        variables: { query: { scope: activeScope, dimension: "State" } },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrganization, currentPermitRegister, props.scope]);

  if (!permitsCountByStates) return null;

  return (
    <RegisterPermitsCounts
      currentOrganization={currentOrganization}
      currentPermitRegister={currentPermitRegister}
      selectedState={props.selectedState}
      onSelectState={props.onSelectState}
      data={permitsCountByStates.permitsCountByStatesMetric.groups.map((d) => ({
        stateKey: STATE_KEY_MAP[d.dimensionKey] ?? (d.dimensionKey as StateKey),
        count: d.value.value,
      }))}
    />
  );
};

export default RegisterPermitsCountsContainer;


